import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ReconTxnListPageUI from './ReconTxnListPageUI.js'
import { getYearList } from '../../../components/common/GetYearList'

class ReconTxnListPageSF extends Component {
  constructor(props) {
    super(props)
    const { yearList, year, period } = getYearList()
    this.state = {
      year,
      yearList,
      period,
      errorList: null,
      month: '',
      monthList: [],
      transactionList: null,
      filteredTransactionList: null,
      selectedTxnId: null,
      searchFilter: '',
      copyToClipboardText: null,
      //
      externalSubmitted: false,
      cancelledSubmitted: false,
      successMsg: null,
      errorList: null,
      //
      updateRemarksMode: false,
      selectedRemarks: null,
      transactionId: null,
      reconciliationStatus: null,
      //
      nodalExtTxnTypeList: [],
      //
      details: false
    }
  }

  render() {
    
    let monthList = [
      { value: '1', label: 'Jan' },
      { value: '2', label: 'Feb' },
      { value: '3', label: 'Mar' },
      { value: '4', label: 'Apr' },
      { value: '5', label: 'May' },
      { value: '6', label: 'Jun' },
      { value: '7', label: 'Jul' },
      { value: '8', label: 'Aug' },
      { value: '9', label: 'Sep' },
      { value: '10', label: 'Oct' },
      { value: '11', label: 'Nov' },
      { value: '12', label: 'Dec' },
    ]
    return (
      <ReconTxnListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountNumber={this.props.match.params.accountNumber}
        on733Click={this.on733Click}
        on441Click={this.on441Click}
        // year-month
        yearList={this.state.yearList}
        monthList={monthList}
        year={this.state.year}
        month={this.state.month}
        onYearChange={this.onYearChange}
        onMonthChange={this.onMonthChange}
        // txn
        transactionList={this.state.transactionList}
        filteredTransactionList={this.state.filteredTransactionList}
        selectedTxnId={this.state.selectedTxnId}
        onRefreshClick={this.onRefreshClick}
        // search, copy
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        //
        onExternalClick={this.onExternalClick}
        externalSubmitted={this.state.externalSubmitted}
        onCancelledClick={this.onCancelledClick}
        cancelledSubmitted={this.state.cancelledSubmitted}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ updateRemarksMode: false }) }}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        selectedRemarks={this.state.selectedRemarks}
        transactionId={this.state.transactionId}
        reconciliationStatus={this.state.reconciliationStatus}
        //
        nodalExtTxnTypeList={this.state.nodalExtTxnTypeList}
        //
        details={this.state.details}
        onDetailsClick={() => {this.setState({details: !this.state.details})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getReconTransactions(context, this.props.match.params.accountNumber, '', '')
    this.getClimeTxnTypeList(context)
  }

  componentDidUpdate(prevProps) {
    let context = this.props.context
    if (this.props.match.params.accountNumber === prevProps.match.params.accountNumber)
      return
    this.getReconTransactions(context, this.props.match.params.accountNumber, this.state.year, this.state.month)
  }

  onYearChange = (option) => {
    let context = this.props.context
    this.setState({ year: option.value })
    this.getReconTransactions(context, this.props.match.params.accountNumber, option.value, this.state.month)
  }

  onMonthChange = (option) => {
    let context = this.props.context
    this.setState({ month: option.value })
    this.getReconTransactions(context, this.props.match.params.accountNumber, this.state.year, option.value)
  }

  onExternalClick = (event) => {
    let txnId = event.target.getAttribute('data-id')
    let externalSubmitted = this.state.externalSubmitted
    if (externalSubmitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      selectedTxnId: txnId,
      externalSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankTransactions/${txnId}/external`,
      this.onExternalClickCallback, {}
    )
  }

  onExternalClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      externalSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelledClick = (event) => {
    let txnId = event.target.getAttribute('data-id')
    let cancelledSubmitted = this.state.cancelledSubmitted
    if (cancelledSubmitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      selectedTxnId: txnId,
      cancelledSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankTransactions/${txnId}/cancelled`,
      this.onCancelledClickCallback, {}
    )
  }

  onCancelledClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      cancelledSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onRefreshClick('noBusy')
      }, 100)
    }
  }

  getReconTransactions(context, accountNumber, year, month) {
    if (!year || !month) {
      year = this.state.year
      month = this.state.month
    }
    if (!year || !month) {
      let yearMonthStr = sessionStorage.getItem(CacheKeys.SelectedYearMonth)
      let yearMonth = yearMonthStr ? JSON.parse(yearMonthStr) : {}
      year = yearMonth.year
      month = yearMonth.month
    }
    if (!year || !month) {
      year = ''
      month = ''
    }
    year = year === 'undefined' ? '' : year
    month = month === 'undefined' ? '' : month

    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/reconciled`,
      cacheKey: CacheKeys.ReconTxns(accountNumber, year, month),
      callback: this.getReconTransactionsCallback,
      ttlInSecs: 600
    })
    console.log(year, month);
    cacheManager.getObject2(context, {}, { year: year, month: month })
  }

  getReconTransactionsCallback = (response) => {
    this.setState({ year: '' + response.yearMonth.year, month: '' + response.yearMonth.month })
    let selectedYearMonth = {year: '' + response.yearMonth.year, month: '' + response.yearMonth.month}
    sessionStorage.setItem(CacheKeys.SelectedYearMonth, JSON.stringify(selectedYearMonth))

    let filtersStr = sessionStorage.getItem(CacheKeys.NodalTxnsFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  getClimeTxnTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/optionLists`,
      cacheKey: CacheKeys.OptionLists(),
      callback: this.getClimeTxnTypeListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getClimeTxnTypeListCallback = (response) => {
    this.setState({ nodalExtTxnTypeList: response.nodalExtTxnTypeList })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.transactionList, searchFilter)
  }

  applyFilters(transactionList, searchFilter, errorList) {
    let filteredList = transactionList
    /*
    if (searchFilter) {
      if (searchFilter.startsWith('4')) {
        if (searchFilter === '4412') {
          filteredList = filteredList.filter(txn =>
            (txn.remitter && txn.remitter.toLocaleLowerCase().startsWith('clime finance') || // disbursements
              !txn.remitter && !txn.payee || // fees, repayments to clime
              txn.payee && txn.payee.toLocaleLowerCase().startsWith('clime finance') // vendor payment
            ) && txn.reconciliationStatus !== 'external_transfer'
          )
        }
      }
      else {
        searchFilter = searchFilter.toLocaleLowerCase()
        filteredList = filteredList.filter(txn =>
          txn.type && txn.type.includes(searchFilter) ||
          txn.reconciliationStatus !== 'reconcile_success' && txn.reconciliationStatus.includes(searchFilter) ||
          txn.particulars.toLocaleLowerCase().includes(searchFilter) ||
          txn.accountName && txn.accountName.toLocaleLowerCase().includes(searchFilter)
        )
      }
    }
    */

    this.setState({
      transactionList: transactionList,
      filteredTransactionList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.NodalTxnsFilter(), JSON.stringify(filters))
  }

  onUpdateRemarksClick = (event) => {
    console.log(this.state.transactionList)
    let transactionId = event.currentTarget.getAttribute('data-transaction-id')
    let reconciliationStatus = event.currentTarget.getAttribute('data-recon-status')

    this.setState({
      updateRemarksMode: true,
      transactionId: transactionId,
      reconciliationStatus: reconciliationStatus
    })
  }

  onRefreshClick = (noBusy) => {
    let year = this.state.year === 'undefined' ? '' : this.state.year
    let month = this.state.month === 'undefined' ? '' : this.state.month
    CacheManager.removeObject(CacheKeys.ReconTxns(this.props.match.params.accountNumber, year, month))
    if (noBusy === 'noBusy') {
      this.getReconTransactions(this.props.context, this.props.match.params.accountNumber, year, month)
    }
    else {
      this.setState({ transactionList: null, errorList: null },
        this.getReconTransactions(this.props.context, this.props.match.params.accountNumber, year, month)
      )
    }
  }
}

export default withRouter(ReconTxnListPageSF)
